import React, { createContext, useContext } from 'react'
import CommandPalette from '@/components/main/CommandPalette'
import { useKeyboardShortcut } from '@/hooks/useKeyboardShortcut'

/* eslint-disable react-refresh/only-export-components -- context module */

interface CommandPaletteContextType {
    open: () => void
    close: () => void
    toggle: () => void
    isOpen: boolean
}

const CommandPaletteContext = createContext<CommandPaletteContextType | undefined>(undefined)

export const useCommandPalette = () => {
    const context = useContext(CommandPaletteContext)
    if (!context) {
        throw new Error('useCommandPalette must be used within CommandPaletteProvider')
    }
    return context
}

interface CommandPaletteProviderProps {
    children: React.ReactNode
}

export const CommandPaletteProvider: React.FC<CommandPaletteProviderProps> = ({ children }) => {
    const { isOpen, open, close, toggle } = useKeyboardShortcut()

    return (
        <CommandPaletteContext.Provider value={{ open, close, toggle, isOpen }}>
            {children}
            <CommandPalette isOpen={isOpen} onClose={close} />
        </CommandPaletteContext.Provider>
    )
}
